import classNames from 'classnames'

import {useIsAutodetectTimeZone} from '../../../hooks/useIsAutodetectTimeZone'
import {useDistanceToNow} from '../../../hooks/useTimeSelector'
import {parseDateToObj} from '../../../utils/dateTimeUtils'
import styles from '../BuildDuration/BuildDurationAnchor/BuildDurationAnchor.module.css'

type Props = {
  started?: string | null
  finished?: string | null
  exact?: boolean
  className?: string
}

export default function BuildStartTime({started, finished, exact, className}: Props) {
  const isAutodetectTimeZone = useIsAutodetectTimeZone()
  const finishedFromNow = useDistanceToNow(finished)

  if (started == null) {
    return null
  }

  if (!exact && finished == null) {
    return null
  }

  if (finished != null && !exact) {
    return (
      <span className={classNames(styles.startedFinished, className)} title="Finished">
        {finishedFromNow}
      </span>
    )
  }

  return (
    <span
      className={classNames(styles.startedFinished, styles.exactStarted, className)}
      title="Start date"
    >
      {parseDateToObj(started, isAutodetectTimeZone).format('D MMM YY LT')}
    </span>
  )
}
